import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReservationFormateurComponent } from './reservationformateur.component';
import { BodisplayModule } from '../../bodisplay';
import { PipeModule } from '../../pipes';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SignatureModule } from '../../signature';

@NgModule({
  declarations: [ReservationFormateurComponent],
  exports: [ReservationFormateurComponent],
  imports: [
    CommonModule,
    BodisplayModule,
    PipeModule,
    NgbModule,
    FormsModule,
    SignatureModule
  ]
})

export class ReservationFormateurModule { }
